import React from "react";
import H2Element from "./h2Element";

const ListShowerModal = ({ data, onClick, title = "Amenities" }) => {
  return (
    <div className="display-modal-center">
      <div className="modal-wrapper">
        {/* Header */}
        <div className="modal-header-section">
          <h2 className="header-title" style={{ color: "black"}}>{title}</h2>
          <button className="close-btn" onClick={onClick} aria-label="Close">
            ✕
          </button>
        </div>
        
        {/* Content */}
        <div className="modal-content-section">
          {Array.isArray(data) && data.length > 0 ? (
            data.map((item, index) => (
              <H2Element 
                key={item.id || index} 
                bgBlue={true} 
                h4 
                value={`${index + 1}. ${item.name}`} 
              />
            ))
          ) : (
            <p className="no-data">No items to display</p>
          )}
        </div>
        
        {/* Footer */}
        <div className="modal-footer-section">
          <button className="button-class-white" style={{ border: "1px solid black"}} onClick={onClick}>
            Close
          </button>
        </div>
      </div>
      
      <style jsx>{`
        .modal-wrapper {
          background: white;
          border-radius: 12px;
          width: 500px;
          max-width: 90vw;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
        }

        .modal-content-section h4 {
        color: black;
        }
        
        .modal-header-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #e5e7eb;
        }
        
        .header-title {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
        }
        
        .close-btn {
          background: none;
          border: none;
          color: black;
          font-size: 24px;
          cursor: pointer;
          padding: 4px 8px;
          line-height: 1;
          transition: color 0.2s;
        }
        
        .close-btn:hover {
          color: black;
          background: transparent;
        }
        
        .modal-content-section {
          padding: 20px 24px;
          max-height: 400px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .button-class-white:hover{
        background: black;
        color: white
        }
        
        .no-data {
          text-align: center;
          color: black;
          padding: 40px 0;
          margin: 0;
        }
        
        .modal-footer-section {
          padding: 16px 24px;
          border-top: 1px solid #e5e7eb;
          display: flex;
          justify-content: flex-end;
        }
      `}</style>
    </div>
  );
};

export default ListShowerModal;